import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import DataTable, { createTheme } from "react-data-table-component";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import { useMaterialUIController } from "context";
import MDTypography from "components/MDTypography";
import EmptyImage from "assets/images/mediacenter/emptyFolder.svg";
import colors from "assets/theme-dark/base/colors";

createTheme(
  "modifiedDarkTheme",
  {
    striped: {
      default: colors.background.default,
    },
    selected: {
      default: colors.background.default,
    },
    background: {
      default: colors.background.card,
    },
  },
  "dark"
);

export default function SessionData({ row, value }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const file = row?.original?.agentSessionData || [];
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const header = [
    {
      name: "Agent ID",
      selector: (row) => row.agentId,
    },
    {
      name: "Name",
      selector: (row) => row.agentName,
    },
    {
      name: "Full Name",
      selector: (row) => row.agentFullName,
    },
    {
      name: "Start Time",
      selector: (row) => row.startDateTime,
    },
    {
      name: "Answer Time",
      selector: (row) => row.answerDateTime,
    },
    {
      name: "End Time",
      selector: (row) => row.endDateTime,
    },
  ];

  return (
    <div>
        <MDTypography
          variant="caption"
          fontWeight="medium"
          color="text"
          onClick={handleClickOpen}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {value}
        </MDTypography>
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={file.length > 0 ? "lg" : "xs"}
        fullWidth={file.length > 0}
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
      >
        <DialogTitle sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          {file.length > 0 ? "Customer Session With Agent" : ""}
          <IconButton
            color="error"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: "8px",
              top: "8px",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          {file.length > 0 ? (
            <DataTable
              columns={header}
              data={file}
              responsive
              pagination
              striped
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10]}
              theme={darkMode ? "modifiedDarkTheme" : "default"} 
              fixedHeader
              persistTableHead
              fixedHeaderScrollHeight={`400px`}
            />
          ) : (
            <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "30px 20px",
              textAlign: "center",
            }}
          >
            <img src={EmptyImage} alt="Empty Folder" />
            <div style={{ fontSize: "18px", color: "text" }}>
              There is no session data available
            </div>
          </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}